<template>
    <v-container class="blue lighten-5">
        <v-card-title>Profile of user</v-card-title>
    </v-container>
</template>

<script>
    export default {
        name: "Profile"
    }
</script>
